import React, { useState, useEffect, useRef } from "react";
import { DatePicker, Select, Form, Typography } from "antd";
import ThumbUpAltOutlinedIcon from "@mui/icons-material/ThumbUpAltOutlined";
import ThumbDownAltOutlinedIcon from "@mui/icons-material/ThumbDownAltOutlined";
import { SyncOutlined, OpenAIOutlined } from "@ant-design/icons";

import Attachment from "../../Images/attachment.svg";


import "./probing.css";

import sourceArrow from "../../Images/sourceArrow.svg";

import ProgressOne from "../../Images/progressOne.svg";
import ProgressTwoGrey from "../../Images/progressTwoGrey.svg";
import ProgressThreeGrey from "../../Images/progressThreeGrey.svg";
import ProgressFourGrey from "../../Images/progressFourGrey.svg";
import ProgressFiveGrey from "../../Images/progressFiveGrey.svg";
import ProgressSixGrey from "../../Images/progressSixGrey.svg";

import ProgressTwoGreen from "../../Images/progressTwoGreen.svg";
import ProgressThreeGreen from "../../Images/progressThreeGreen.svg";
import ProgressFourGreen from "../../Images/progressFourGreen.svg";
import ProgressFiveGreen from "../../Images/progressFiveGreen.svg";
import ProgressSixGreen from "../../Images/progressSixGreen.svg";

import masterResetNoIcon from "../../Images/masterResetNoIcon.svg";
import ImageGallery from "../ImageGallery/ImageGallery";
import SectionOne from "../Sections/SectionOne";
import SectionTwo from "../Sections/SectionTwo";
import SectionThree from "../Sections/SectionThree";
import SectionFour from "../Sections/SectionFour";
import SectionFive from "../Sections/SectionFive";
import SectionSix from "../Sections/SectionSix";
import LLM from "./Steps/LLM";
import SystemCheck from "./Steps/SystemCheck";
import Resolution from "./Steps/Resolution";
import ProbingTab from "./Steps/ProbingTab";
import CallLogs from "./Steps/CallLogs";

const { Option } = Select;
const { Title } = Typography;

function Probing(props) {
  const {
    setIsFeedbackPop,
    data,
    scrollToBottom,
    setMessageBoard,
    messageBoard,
    showMaximumChat,
  } = props;

  const [probingCheck, setProbingCheck] = useState([]);

  const [toggleOption, setToggleOption] = useState({});
  const [masterResetTap, setmasterResetTab] = useState(false);
  const [errorTabEnable, setErrorTabEnable] = useState(false);
  const [workOrderTab, setWorkOrderTab] = useState(false);

  // State to track the selected option for each set
  const [selectedOptions, setSelectedOptions] = useState([
    true,
    false,
    false,
    false,
    false,
    false,
    false,
  ]);

  //------
  const [date, setDate] = useState(null);
  const [time, setTime] = useState(null);

  const handleDateChange = (date) => {
    setDate(date);
  };

  const handleTimeChange = (value) => {
    setTime(value);
  };
  //----

  const handleRadioChange = (key) => {
    if (probingCheck?.includes(key)) {
      setProbingCheck(probingCheck?.filter((item) => item !== key));
    } else {
      setProbingCheck([...probingCheck, key]);
    }
  };

  const options = [
    ProgressOne,
    selectedOptions[1] ? ProgressTwoGreen : ProgressTwoGrey,
    selectedOptions[2] ? ProgressThreeGreen : ProgressThreeGrey,
    selectedOptions[3] ? ProgressFourGreen : ProgressFourGrey,
    selectedOptions[4] ? ProgressFiveGreen : ProgressFiveGrey,
    selectedOptions[5] ? ProgressSixGreen : ProgressSixGrey,
  ];

  const selections = [
    { id: 1, name: "yesNo" },
    { id: 2, name: "activeDeactive" },
    { id: 3, name: "yesNo" },
    { id: 4, name: "activeDeactive" },
    { id: 5, name: "yesNo" },
    { id: 6, name: "activeDeactive" },
    // Add more groups as needed
  ];

  // Function to handle button click and update selectedOptions state
  const handleButtonClick = (id, option) => {
    setToggleOption((prevOptions) => ({
      ...prevOptions,
      [id]: option,
    }));
    // Perform other actions based on the toggle option clicked
  };

  useEffect(() => {
    // Call scrollToBottom on selectedOptions update
    scrollToBottom();
  }, [selectedOptions]);

  //switching
  const [tabKey, setTabKey] = useState("default");
  const boxRef = useRef();

  useEffect(() => {
    if (errorTabEnable) {
      setTabKey("errorTabEnable");
    } else if (masterResetTap) {
      setTabKey("masterResetTap");
    } else if (workOrderTab) {
      setTabKey("workOrderTab");
    } else {
      setTabKey("default");
    }
  }, [errorTabEnable, masterResetTap, workOrderTab]);

  useEffect(() => {
    if (boxRef.current) {
      const box = boxRef.current;
      box.classList.add("fade-in");
      const timeout = setTimeout(() => {
        box.classList.remove("fade-in");
      }, 500);
      return () => clearTimeout(timeout);
    }
  }, [tabKey]);

  const errorTab = () => {
    return (
      <div ref={boxRef} className="box">
        <span className="error-head">Error Message - No Signal</span>
        <div className="error-container">
          <div className="error-side-nav">
            {options.map((option, index) => (
              <img
                key={index}
                src={option}
                style={{
                  height: "clamp(32px, 4vw, 72px)",
                  width: "clamp(16px, 4vw, 32px)",
                }}
              ></img>
            ))}
          </div>
          <div className="error-message-container">
            {/* {getSectionOne()} */}
            <SectionOne
              handleButtonClick={handleButtonClick}
              setSelectedOptions={setSelectedOptions}
              selectedOptions={selectedOptions}
              toggleOption={toggleOption}
              setMessageBoard={setMessageBoard}
              setErrorTabEnable={setErrorTabEnable}
            />

            {selectedOptions[1] && (
              <>
                <div className="error-line"></div>
                {/* {getSectionTwo()} */}
                <SectionTwo
                  handleButtonClick={handleButtonClick}
                  setSelectedOptions={setSelectedOptions}
                  selectedOptions={selectedOptions}
                  toggleOption={toggleOption}
                  setMessageBoard={setMessageBoard}
                  setErrorTabEnable={setErrorTabEnable}
                />
              </>
            )}
            {selectedOptions[2] && (
              <>
                <div className="error-line"></div>
                {/* {getSectionThree()} */}
                <SectionThree
                  handleButtonClick={handleButtonClick}
                  setSelectedOptions={setSelectedOptions}
                  selectedOptions={selectedOptions}
                  toggleOption={toggleOption}
                  setMessageBoard={setMessageBoard}
                  setErrorTabEnable={setErrorTabEnable}
                />
              </>
            )}
            {selectedOptions[3] && (
              <>
                <div className="error-line"></div>
                {/* {getSectionFour()} */}
                <SectionFour
                  handleButtonClick={handleButtonClick}
                  setSelectedOptions={setSelectedOptions}
                  selectedOptions={selectedOptions}
                  toggleOption={toggleOption}
                  setMessageBoard={setMessageBoard}
                  setErrorTabEnable={setErrorTabEnable}
                />
              </>
            )}
            {selectedOptions[4] && (
              <>
                <div className="error-line"></div>
                {/* {getSectionFive()} */}
                <SectionFive
                  handleButtonClick={handleButtonClick}
                  setSelectedOptions={setSelectedOptions}
                  selectedOptions={selectedOptions}
                  toggleOption={toggleOption}
                  setMessageBoard={setMessageBoard}
                  setErrorTabEnable={setErrorTabEnable}
                  setmasterResetTab={setmasterResetTab}
                />
              </>
            )}
            {selectedOptions[5] && (
              <>
                <div className="error-line"></div>
                {/* {getSectionSix()} */}
                <SectionSix
                  handleButtonClick={handleButtonClick}
                  setSelectedOptions={setSelectedOptions}
                  selectedOptions={selectedOptions}
                  toggleOption={toggleOption}
                  setMessageBoard={setMessageBoard}
                  setErrorTabEnable={setErrorTabEnable}
                  setWorkOrderTab={setWorkOrderTab}
                />
              </>
            )}
          </div>
        </div>
      </div>
    );
  };

  const resetTab = () => {
    return (
      <div ref={boxRef} className="box">
        <span className="error-head">Master Reset Procedure</span>
        <div className="error-container">
          <div className="error-side-nav">
            <img
              key={"1"}
              src={masterResetNoIcon}
              style={{ height: "72px", width: "32px" }}
            ></img>
          </div>
          <div className="error-message-container">
            <div style={{ paddingTop: "0px" }} className="error-message-head1">
              Check if the subscriber want to perform “Master Reset”
            </div>
            <div style={{ gap: "8px", display: "flex", marginTop: "22px" }}>
              <button
                onClick={() => {
                  handleButtonClick(4, "yes");
                }}
                className={`error-button ${
                  toggleOption[4] === "yes" ? "clicked" : ""
                }`}
                // disabled={selectedOptions[4]}
              >
                Yes
              </button>
              <button
                onClick={() => {
                  handleButtonClick(4, "no");
                }}
                className={`error-button ${
                  toggleOption[4] === "no" ? "clicked" : ""
                }`}
                // disabled={selectedOptions[4]}
              >
                No
              </button>
            </div>
            <button
              className="submit-wo"
              onClick={() => {
                setmasterResetTab(false);
                setErrorTabEnable(true);
              }}
              style={{ width: "180px", marginTop: "12px" }}
            >
              Go Back to Troubleshoot
            </button>
            <div className="error-message-head2">
              1. Press "Organizer / Setting" button from the TataPlay remote
            </div>
            <div className="error-message-head2">
              2. Select "System Settings" from the menu.
            </div>
            <ImageGallery />
          </div>
        </div>
      </div>
    );
  };

  const createWorkOrderTab = () => {
    return (
      <div ref={boxRef} className="box">
        <span className="error-head">CREATE WORK ORDER</span>
        <div style={{ top: "0px" }} className="error-container">
          <div
            style={{ backgroundColor: "#eff0ee" }}
            className="error-message-container"
          >
            <div className="error-message-head2">
              We are sorry for the inconvenience!
            </div>
            <div className="error-message-head2">
              Visit Charges are subject to your account level warranty. Material
              charges if applicable will be informed during the installer visit.
            </div>
            <div className="error-message-head2">
              Please select your preferred date & time and we will send our
              technician to fix this issue for you!
            </div>

            <div>
              <Form style={{ width: "50%" }} layout="vertical">
                <Title
                  style={{ fontSize: "14px" }}
                  className="error-message-head2"
                  level={4}
                >
                  Select Date
                </Title>
                <Form.Item>
                  <DatePicker
                    onChange={handleDateChange}
                    style={{ width: "100%" }}
                    placeholder="Select Date"
                  />
                </Form.Item>

                <Title
                  style={{ fontSize: "14px" }}
                  className="error-message-head2"
                  level={4}
                >
                  Select Time
                </Title>
                <Form.Item>
                  <Select
                    onChange={handleTimeChange}
                    placeholder="Select Time"
                    style={{ width: "100%" }}
                  >
                    <Option value="10 AM to 12 PM">10 AM to 12 PM</Option>
                    <Option value="12 PM to 3 PM">12 PM to 3 PM</Option>
                    <Option value="4 PM to 6 PM">4 PM to 6 PM</Option>
                    <Option value="6 PM to 8 PM">6 PM to 8 PM</Option>
                  </Select>
                </Form.Item>
              </Form>
            </div>
            <div style={{ display: "flex", gap: "10px" }}>
              <button
                className="submit-wo"
                style={{ width: showMaximumChat ? "20%" : "25%" }}
              >
                Submit
              </button>
              <button
                className="cancel-wo"
                style={{ width: showMaximumChat ? "25%" : "35%" }}
                onClick={() => {
                  setWorkOrderTab(false);
                  setErrorTabEnable(true);
                }}
              >
                Cancel WO
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  };

  const switchTabs = () => {
    switch (true) {
      case errorTabEnable:
        return errorTab();
      case masterResetTap:
        return resetTab();
      case workOrderTab:
        return createWorkOrderTab();
      default:
        return null;
    }
  };

  return (
    <div>
      {messageBoard ? (
        <>{switchTabs()}</>
      ) : (
        // <>{createWorkOrderTab()}</>
        <div>
          {data?.llm_response?.llm_response && <span>{data?.message}</span>}
          {Object.entries(data?.llm_response).map(([key, value]) => {
            return (
              <>
                {key === "llm_response" && (
                  <LLM item={data?.llm_response?.llm_response} />
                )}
                {key === "probing" && (
                  <ProbingTab
                    item={data?.llm_response?.probing} 
                    probingCheck={probingCheck}
                    handleRadioChange={handleRadioChange}
                  />
                )}
                {key === "system_check" && (
                  <SystemCheck item={data?.llm_response?.system_check} />
                )}
                {key === "resolution" && (
                  <Resolution item={data?.llm_response?.resolution} />
                )}
                {key === "Call_log_type" && (
                  <CallLogs
                    item={data?.llm_response}
                    showMaximumChat={showMaximumChat}
                  />
                )}
              </>
            );
          })}
          {!showMaximumChat && data?.llm_response?.webpage  && (
            <div style={{marginTop : '20px' , marginLeft :'10px'}}>
              <span className="sources-text">Sources</span>

                <p style={{ margin: "5px"}}>
                  <a
                    href={data?.llm_response?.webpage}
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{display :'flex' , justifyContent : 'space-between' , alignItems : 'center' , color : '#220046' , textDecoration : 'none'}}
                  >
                    <div>{data?.llm_response?.source_title ||
                      data?.llm_response?.webpage}</div>
                    

                    <img style={{width : '20px'}} src={sourceArrow} alt="srcIcon"></img>
                  </a>
                
                </p>
                
            </div>
          )}
        </div>
      )}
    </div>
  );
}

export default Probing;
